"use client";

import { Table } from "@tanstack/react-table";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Button } from "@/components/ui/button";
import { DataTableViewOptions } from "@/components/admin/UserTable/data-table-view-options";
import { ORDERS_SU2M } from "@/client-admin/types.gen.ts";
import { getUniqueDatesFromSumOrders, getUniqueIntradayCodesFromSumOrders, orderTypes, statusesBCI } from "./columns";
import { DataTableFacetedFilter } from "./data-table-faceted-filter";
import { DeleteOrdersDialog } from "./DeleteOrdersDialog";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  data: TData[];
}

export function DataTableToolbar<TData>({ table, data }: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;
  const uniqueDates = getUniqueDatesFromSumOrders(data as ORDERS_SU2M[]);
  const uniqueIntradayCodes = getUniqueIntradayCodesFromSumOrders(data as ORDERS_SU2M[]);
  const selectedRows = table.getFilteredSelectedRowModel().rows;
  const selectedIds = selectedRows.map((row) => (row.original as ORDERS_SU2M).orderId);

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        {selectedRows.length > 0 && (
          <DeleteOrdersDialog orderIds={selectedIds} selectedCount={selectedRows.length} table={table} />
        )}
        {table.getColumn("intradayCode") && (
          <DataTableFacetedFilter
            column={table.getColumn("intradayCode")}
            title="Intraday Code"
            options={uniqueIntradayCodes}
          />
        )}

        {table.getColumn("date") && (
          <DataTableFacetedFilter column={table.getColumn("date")} title="Date" options={uniqueDates} />
        )}
        {table.getColumn("statusBCI") && (
          // @ts-expect-error allow filter for null value
          <DataTableFacetedFilter column={table.getColumn("statusBCI")} title="Status BCI" options={statusesBCI} />
        )}
        {table.getColumn("orderType") && (
          <DataTableFacetedFilter column={table.getColumn("orderType")} title="Order Type" options={orderTypes} />
        )}
        {isFiltered && (
          <Button variant="ghost" onClick={() => table.resetColumnFilters()} className="h-8 px-2 lg:px-3">
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  );
}
